<div [@routerTransition]>
    <div class="container-fluid">
        @if (!isTemplateFlow) {
            <div class="row my-2">
                <div class="col-6">
                    <app-back-button (triggered)="goBack()"></app-back-button>
                </div>
            </div>
        }
        <div class="row">
            <div class="col-12">
                <div class="card card-custom gutter-b career-competencies-card">
                    @if (!isTemplateFlow) {
                        <div class="card-header">
                            <div class="container-fluid my-auto">
                                <div class="row justify-content-center my-3">
                                    <div class="col-lg-6">
                                        <h3 class="card-title align-items-start flex-column">
                                            <span class="font-weight-bolder">
                                                {{ title }}
                                            </span>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
					
					<div class="card-body">
						<div class="row justify-content-center">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <p-floatLabel>
                                        <input #contentInput="ngModel"
                                            pInputText 
                                            class="w-100"
                                            type="text"
                                            [(ngModel)]="content"
                                            name="contentInput"
											[ngClass]="{ 'ng-invalid ng-dirty': isEmptyString(content) && contentInput.touched }"
                                            disabled="false"/>
                                        <label for="contentInput">
                                            <app-label-content [isRequired]="true">
                                                {{ l('::Content') }}
                                            </app-label-content>
                                        </label>
                                    </p-floatLabel>

                                    @if (isEmptyString(content) && contentInput.touched) {
										<span class="text-danger">
                                            {{ l('::ContentIsRequired') }}
										</span>
									}
                                </div>

                                <div class="form-group row mt-4">
                                    <div class="col-lg-6 col-sm-12">
                                        <app-question-type-dropdown
                                            [isRequired]="true"
                                            [questionType]="type"
                                            (changeQuestionType)="onSelectType($event)">
                                        </app-question-type-dropdown>
                                    </div>
                                    <div class="col-lg-6 col-sm-12">
                                        <app-question-state-dropdown
                                            [isRequired]="true"
                                            [isDisabled]="isTemplateFlow"
                                            (changeQuestionState)="onSelectState($event)"
                                            [selectedQuestionState]="state">
                                        </app-question-state-dropdown>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <app-toggle-switch
                                        [label]="l('::IsCommon')"
                                        [checked]="isCommon"
                                        [disabled]="isTemplateFlow"
                                        (triggered)="onIsCommonChange($event)">
                                    </app-toggle-switch>
                                </div>

                                <div class="form-group">
                                    <app-question-group-dropdown
                                        (changeQuestionGroup)="onSelectQuestionGroup($event)"
                                        [isCommon]="isCommon"
                                        [isDisabled]="isTemplateFlow"
                                        [questionGroup]="questionGroup">
                                    </app-question-group-dropdown>
                                </div>
							</div>
						</div>
					</div>

					<div class="card-footer">
                        <app-basic-card-footer
                            (back)="goBack()"
                            (save)="saveQuestion()"
                            [showCancelButton]="!isTemplateFlow"
                            [isSaveDisabled]="!isValidQuestion()">
                        </app-basic-card-footer>
                    </div>    
                </div>
            </div>
        </div>
    </div>
</div>